import Compressor from '@uppy/compressor';
import CompressorJS from 'compressorjs';

export default class EnhancedCompressor extends Compressor {
  // https://github.com/transloadit/uppy/blob/main/packages/%40uppy/compressor/src/index.js#L33
  compress(blob) {
    // If convert options include 'format' option, the config will include the mimeType for that format
    // In those cases, we want to coerce the image to that file type.
    // Otherwise, ignore modifying gifs
    if ((!this.opts.mimeType || this.opts.mimeType === 'image/gif') && blob.type === 'image/gif') {
      return blob;
    }
    return new Promise((resolve, reject) => {
      /* eslint-disable no-new */
      new CompressorJS(blob, {
        ...this.opts,
        success: resolve,
        error: reject,
      });
    });
  }
}
